import {randomString} from '../../helpers/utilities/stringHelpers';

/* Used to distinguish concurrent app instances in traces/logs. */
export const sessionId = randomString(4);
